import { AUTH_TRANSLATIONS } from './translations/auth';
import { CARRIER_TRANSLATIONS } from './translations/carrier';
import { COMMON_TRANSLATIONS } from './translations/common';
import { CUSTOMER_TRANSLATIONS } from './translations/customer';
import { LANDING_TRANSLATIONS } from './translations/landing';
import { REQUEST_TRANSLATIONS } from './translations/request';

// Russian source strings are stable keys so the original Figma copy remains untouched.
export const EN_TRANSLATIONS: Record<string, string> = {
  ...COMMON_TRANSLATIONS,
  ...LANDING_TRANSLATIONS,
  ...AUTH_TRANSLATIONS,
  ...REQUEST_TRANSLATIONS,
  ...CUSTOMER_TRANSLATIONS,
  ...CARRIER_TRANSLATIONS,
};
